import { render, staticRenderFns } from "./QuizTeamGameLobby.vue?vue&type=template&id=1a765279&scoped=true&"
import script from "./QuizTeamGameLobby.vue?vue&type=script&lang=js&"
export * from "./QuizTeamGameLobby.vue?vue&type=script&lang=js&"
import style0 from "./QuizTeamGameLobby.vue?vue&type=style&index=0&id=1a765279&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a765279",
  null
  
)

export default component.exports